module.exports = __webpack_public_path__ + "img/halloween-castle-2.40a8fca9.svg";